import { createApiCall } from 'lib/base';

const UPDATE_USER_ASSIGNMENT = 'WEALTH/UPDATE_USER_ASSIGNMENT';

const apiCall = createApiCall(
  UPDATE_USER_ASSIGNMENT,
  ({ id, payload }: { id: string; payload: any }) => ({
    endpoint: `/api/admin/wealth/user-assignments/${id}`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);

export default apiCall;
